import {
  emailTemplateSchema,
  type EmailTemplate,
} from "@redotech/redo-marketing-templates-common/email-template";
import {
  savedEmailTemplateSchema,
  type SavedEmailTemplate,
} from "@redotech/redo-marketing-templates-common/saved-email-template";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateSavedEmailTemplate = {
  name: "updateSavedEmailTemplate" as const,
  input: z.object({
    savedTemplateId: zExt.objectId(),
    updates: z
      .object({
        template: (emailTemplateSchema as z.ZodType<EmailTemplate>).optional(),
        templateName: z.string().optional(),
      })
      .partial(),
  }),
  output: savedEmailTemplateSchema as z.ZodType<SavedEmailTemplate>,
};
